const setProfileShape = new Map();

setProfileShape.set('firstName', {
  width: '16',
  placeholder: 'Max',
  label: 'common.firstname',
  required: true,
});

setProfileShape.set('lastName', {
  width: '16',
  placeholder: 'Mustermann',
  label: 'common.lastname',
  required: true,
});

setProfileShape.set('nickname', {
  width: '16',
  placeholder: 'mmuster',
  label: 'common.nickname',
  required: true,
});

setProfileShape.set('mobileNumber', {
  width: '16',
  placeholder: '+49846598741',
  label: 'usersConfig.phone',
  required: true,
});

export default setProfileShape;



// WEBPACK FOOTER //
// ./src/shapes/setProfileShape.js